'use client';

import ClipLoader from 'react-spinners/CircleLoader';

export default function Spinner() {
  return (
    <div className="flex h-screen w-full justify-center">
      <ClipLoader
        className="mt-36"
        color={'#65a30d'}
        size={50}
        loading={true}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  );
}
